import { useMemo } from 'react';
import { Badge, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import type { PlanAssetRow } from '../types';
import { formatAssetLabel, formatDate } from '../utils';

const { Text } = Typography;

export function usePlanDetailAssetColumns(): ColumnsType<PlanAssetRow> {
  const { t } = useTranslation('maintenance');

  return useMemo(
    () => [
      {
        title: t('detail.assets.asset'),
        key: 'asset',
        render: (_: unknown, row: PlanAssetRow) => (
          <div>
            <Text strong>
              {formatAssetLabel(row.assetName, row.serialNumber)}
            </Text>
            {row.siteName ? (
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {row.siteName}
                </Text>
              </div>
            ) : null}
          </div>
        ),
      },
      {
        title: t('plans.active'),
        dataIndex: 'active',
        key: 'active',
        width: 120,
        render: (val: boolean) =>
          val ? (
            <Badge status="success" text={t('common.active')} />
          ) : (
            <Badge status="default" text={t('common.inactive')} />
          ),
      },
      {
        title: t('detail.assets.startDate'),
        dataIndex: 'startDate',
        key: 'startDate',
        render: (val: string) => formatDate(val),
      },
      {
        title: t('detail.assets.assignedAt'),
        dataIndex: 'assignedAt',
        key: 'assignedAt',
        render: (val: string) => formatDate(val),
      },
    ],
    [t],
  );
}
